var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4141 12.0001L15.9999 6.41429C16.3904 6.02376 16.3904 5.3906 15.9999 5.00008C15.6094 4.60955 14.9762 4.60955 14.5857 5.00007L7.58571 12.0001L14.5857 19.0001C14.9762 19.3906 15.6094 19.3906 15.9999 19.0001C16.3904 18.6096 16.3904 17.9764 15.9999 17.5859L10.4141 12.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowBack);
export default __webpack_public_path__ + "static/media/ic_arrow_back.63cd8af9c3b6024d0e5fdc2c18e20e0d.svg";
export { ForwardRef as ReactComponent };